module.exports = __webpack_public_path__ + "static/media/IconCopyLink.8162555d.svg";